import "../Page/Page.css";
import React, { useMemo, useState } from "react";

interface YouTubeVideoProps {
  /** Either a bare YouTube video ID or a full YouTube URL (watch/embed/youtu.be/shorts). */
  videoId: string;
  constrainToParent?: boolean;
  title?: string | false;
  /** Start with the "repeat" toggle already on. Defaults to off. */
  defaultLoop?: boolean;
}

// Pulls the 11-character video ID out of any common YouTube URL shape;
// if none matches, assumes the caller already passed a bare ID.
export const extractYouTubeId = (input: string): string => {
  const match = input.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=|shorts\/))([\w-]{11})/
  );
  return match ? match[1] : input;
};

const YouTubeVideo: React.FC<YouTubeVideoProps> = ({
  videoId,
  constrainToParent = false,
  title = false,
  defaultLoop = false,
}) => {
  // Add `setLoop` back here when restoring the titled card layout (it drives the Repeat toggle).
  const [loop] = useState(defaultLoop);
  const id = useMemo(() => extractYouTubeId(videoId), [videoId]);

  const source = useMemo(() => {
    const params = new URLSearchParams({ rel: "0" });
    if (loop) {
      // YouTube only loops a single video when playlist is set to that
      // same video's ID alongside loop=1.
      params.set("loop", "1");
      params.set("playlist", id);
    }
    return `https://www.youtube.com/embed/${id}?${params.toString()}`;
  }, [id, loop]);

  return (
    <div className="video-container" style={constrainToParent ? { marginTop: '5vw', marginBottom: "3vw" } : undefined}>
      <div className="image-background">
        <iframe
          key={source}
          className="OPTVideo1"
          src={source}
          title={typeof title === "string" ? title : "YouTube video"}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={constrainToParent ? { width: '60vw', height: 'auto', aspectRatio: '16/9' } : undefined}
        />
      </div>
    </div>
  );

  // Titled card layout with Repeat toggle (styles live in Page2.css under `.video-container .inv-item`
  // and `.video-loop-toggle`). Restore `setLoop` above and swap this in for the return block.
  // return (
  //   <div className="video-container" style={constrainToParent ? { marginTop: '5vw', marginBottom: "3vw" } : undefined}>
  //     <div className="inv-items">
  //       <div className="inv-item">
  //         <div className="inv-item-title-bar">
  //           {title && <h4 className="inv-item-title">{title}</h4>}
  //           <button
  //             type="button"
  //             className={`video-loop-toggle${loop ? " active" : ""}`}
  //             onClick={() => setLoop((prev) => !prev)}
  //             aria-pressed={loop}
  //           >
  //             <span className="video-loop-toggle-dot" />
  //             Repeat {loop ? "On" : "Off"}
  //           </button>
  //         </div>
  //         <div className="image-background">
  //           <iframe
  //             key={source}
  //             className="OPTVideo1"
  //             src={source}
  //             title={typeof title === "string" ? title : "YouTube video"}
  //             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  //             allowFullScreen
  //             style={constrainToParent ? { width: '60vw', height: 'auto', aspectRatio: '16/9' } : undefined}
  //           />
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default YouTubeVideo;
